import React, { useState, useEffect } from 'react';
import AdventTerms from './advent_terms';
import AdventPolicy from './advent_policy';
import AdventPolicyFr from './advent_policy-fr';
import AdventChild from './advent_enfants';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import DownloadButton from './downloadButton';

const AboutContent = () => (
  <>
    <h2>A propos de Calendrier de l'Advent</h2>
    <p>Un Calendrier de l'Advent personnalisé par votre entourage pour vous.</p>
    <p>Invitez vos amis, votre famille et construisez une super expérience pour vos proches et vous</p>
  </>
);
// <h3>Screenshots</h3>
// <div className="screenshots">
//   <img src="/LetBeHappier/1_home.png" alt="Happy Now Screenshot 1" />
//   <img src="/LetBeHappier/2_feeling.png" alt="Happy Now Screenshot 2" />
//   <img src="/LetBeHappier/3_pensees.png" alt="Happy Now Screenshot 3" />
//   <img src="/LetBeHappier/4_sum.png" alt="Happy Now Screenshot 4" />
//   <img src="/LetBeHappier/5_histo.png" alt="Happy Now Screenshot 5" />
// </div>


function getPlatform() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return 'ios';
  }
  if (/android/i.test(ua)) {
    return 'android';
  }
  return 'other';
}

function Advent() {
  const [activeView, setActiveView] = useState('about');

  useEffect(() => {
    // On component mount, check the URL hash and set the active view accordingly.
    const hash = window.location.hash.substring(1);
    if (['about', 'terms', 'policy', 'policy-fr'].includes(hash)) {
      setActiveView(hash);
    }
    const isInvitePath = window.location.pathname === '/advent/invite';
    const code = new URLSearchParams(window.location.search).get('code');

    if (isInvitePath && code) {
      fetch('/api/invite/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });

      const platform = getPlatform();

      if (platform === 'ios') {
        window.location.href = 'https://apps.apple.com/app/com.pastrycias.adventCalendar2026';
      } else if (platform === 'android') {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.pastrycias.advent_calendar_2026';
      }
      // sinon (desktop / autre) : on ne redirige pas, on laisse afficher la page
      // par exemple avec un QR code ou un message "ouvre ce lien depuis ton téléphone"
    }
  }, []); // Empty dependency array ensures this runs only once on mount.


  const handleLinkClick = (e, view) => {
    e.preventDefault();
    setActiveView(view);
    // Update the URL hash to allow for direct linking, without reloading the page.
    window.history.pushState(null, '', `#${view}`);
  };

  return (
    <div className="advent2026-container">
      <div className="advent2026-left-column">
        <h3>Calendrier de l'avent : </h3>
        <div className="download-buttons">
          <DownloadButton platform="Android" link="https://play.google.com/store/apps/details?id=com.pastrycias.advent_calendar_2026" Icon={FaGooglePlay} />
          <DownloadButton platform="iOS" link="https://apps.apple.com/fr/app/happy-now/6815516384" Icon={FaApple} />
          {/*<DownloadButton platform="TikTok" link="#" image="/logos/tiktok.svg" />
          <DownloadButton platform="Instagram" link="https://www.instagram.com/happynowtheapp/" image="/logos/instagram.svg" />
          <DownloadButton platform="Youtube" link="#" image="/logos/youtube.svg" /> */}
        </div>
        <div className="legal-links">
          <a href="#about" className={activeView === 'about' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'about')}>A propos</a>
          <a href="#child" className={activeView === 'child' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'child')}>Standards de sécurité des enfants</a>
          <a href="#terms" className={activeView === 'terms' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'terms')}>Terms of Service</a>
          <a href="#policy" className={activeView === 'policy' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy')}>Privacy Policy</a>
          <a href="#policy-fr" className={activeView === 'policy-fr' ? 'active-legal-link' : ''} onClick={(e) => handleLinkClick(e, 'policy-fr')}>Politique de confidentialité</a>
        </div>
      </div>
      <div className="advent2026-right-column">
        {activeView === 'about' && <AboutContent />}
        {activeView === 'terms' && <AdventTerms />}
        {activeView === 'policy' && <AdventPolicy />}
        {activeView === 'policy-fr' && <AdventPolicyFr />}
        {activeView === 'child' && <AdventChild />}
      </div>
    </div>
  );
}

export default Advent;
